import { useColorMode, useSetColorMode } from '@atlaskit/app-provider';
import { ButtonItem } from '@atlaskit/menu';
import { Stack } from '@atlaskit/primitives';
import { useCallback } from 'react';

export type ColorMode = 'light' | 'dark' | 'auto';

export const ThemeSection = () => {
	const setColorMode = useSetColorMode();
	const currentColorMode = useColorMode();
	const updateTheme = useCallback(
		(newColorMode: ColorMode) => {
			if (newColorMode === currentColorMode) {
				return;
			}
			setColorMode(newColorMode);
			window.localStorage.setItem('themeColorMode', newColorMode);
		},
		[setColorMode, currentColorMode],
	);

	return (
		<Stack>
			<ButtonItem onClick={() => updateTheme('light')}>Light</ButtonItem>
			<ButtonItem onClick={() => updateTheme('dark')}>Dark</ButtonItem>
			<ButtonItem onClick={() => updateTheme('auto')}>System</ButtonItem>
		</Stack>
	);
};
